import { render, staticRenderFns } from "./ConfirmLabmanager.vue?vue&type=template&id=0892d0da&"
import script from "./ConfirmLabmanager.vue?vue&type=script&lang=js&"
export * from "./ConfirmLabmanager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports